import qs from 'qs';
import { get } from 'lodash';
import { SessionApply, SessionPredicate } from '../sessionType';
import { FEELIX_THEMES, STEP_PATH, SUBSCRIPTION_TYPE } from '../../../constants';

export const hasQuoteAppSession: SessionPredicate = (history) => {
  const { search, pathname } = history.location;
  const queryString = qs.parse(search, { ignoreQueryPrefix: true });
  const quoteId = get(queryString, 'quoteReference') as string;
  const hasRequiredParams = Boolean(quoteId);
  return pathname.includes(STEP_PATH.QUOTE.ROOT) && hasRequiredParams;
}

export const updateQuoteAppSession: SessionApply = (history, setState) => {
  const { search } = history.location;

  const queryString = qs.parse(search, { ignoreQueryPrefix: true });
  const quoteId = get(queryString, 'quoteReference') as string;

  setState({
    theme: FEELIX_THEMES.MODERN,
    subscriptionType: SUBSCRIPTION_TYPE.QUOTE,
    quoteId,
    useLegacy: false
  });
};
